const PLATFORM_NAMES: Record<string, string> = {
    angi: "Angi",
    bbb: "the BBB",
    facebook: "Facebook",
    google: "Google",
    homeadvisor: "HomeAdvisor",
    nextdoor: "Nextdoor",
    thumbtack: "Thumbtack",
    yelp: "Yelp",
  },
  joinWithAnd = (names: string[]): string => {
    if (names.length <= 2) {
      return names.join(" and ");
    }
    return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
  },

  /**
   * "Real customer reviews from Google, Facebook, and Yelp", in the order given, or
   * null when no platform can be named — `other` has no name to give.
   */
  describeReviewSources = (sources: readonly string[] | undefined): string | null => {
    const names = [...new Set(sources ?? [])].flatMap((source) => PLATFORM_NAMES[source] ?? []);
    if (names.length > 0) {
      return `Real customer reviews from ${joinWithAnd(names)}`;
    }
    return null;
  };

export { describeReviewSources };
